import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import {
  apiPackagesDetailGet,
  apiPackagesListAll,
  apiPackagesListGet,
  apiPackagesParcelPickerGet,
} from '@/entities/packages/modules/api/packages';
import type {
  ApiPackagesListParams,
  ApiPackagesParcelPickerParams,
} from '@/shared/types/api/packages';

export const usePackagesList = (params: ApiPackagesListParams) =>
  useFetch({
    api: () => apiPackagesListGet(params),
    keywords: queryKeys.packages.list(params),
    staleTime: 60_000,
  });

/** Fetch-all variant (every page) — see `apiPackagesListAll`. */
export const usePackagesListAll = (
  params: Omit<ApiPackagesListParams, 'page' | 'page_size'>,
) =>
  useFetch({
    api: () => apiPackagesListAll(params),
    keywords: queryKeys.packages.list({ ...params, all: true }),
    staleTime: 60_000,
  });

export const usePackageDetail = (id: string | undefined) =>
  useFetch({
    api: () => apiPackagesDetailGet(id ?? ''),
    keywords: queryKeys.packages.detail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });

export const usePackagesParcelPicker = (
  params: ApiPackagesParcelPickerParams,
  enabled = true,
) =>
  useFetch({
    api: () => apiPackagesParcelPickerGet(params),
    keywords: queryKeys.packages.parcelPicker(params),
    enabled,
    staleTime: 30_000,
  });
